import { NavLink } from "react-router-dom";
import styles from "./goback.module.css";
import { HiArrowLeft } from "react-icons/hi2";

function GoBack({ backRoute, backState }) {
    return ( 
        <NavLink to={backRoute} state={backState} className={styles.goBack}>
            <HiArrowLeft size={22} color={"var(--text)"}/>
        </NavLink>
    )
}

export default GoBack;